<template>
  <div data-testid="select-establishment">
    <v-select
      v-model="selected"
      :items="list"
      label="Establishment"
      outlined
      class="me-4 mt-7"
      dense
      item-text="name"
      item-value="id"
      :disabled="loading"
      :loading="loading"
      style="width: 25rem"
      @input="onSelect"
    ></v-select>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import { fetchAssociatedEstablishments } from '@/services/establishments/establishments.service';
import { EVENT_LIST_BY_ESTABLISHMENT } from '@/router/constants';

export default {
  name: 'SelectEstablishment',
  data: () => ({
    list: [],
    selected: null,
    loading: false,
  }),
  computed: {
    ...mapGetters('establishmentsStore', ['getCurrentEstablishment']),
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    ...mapActions('establishmentsStore', [
      'SET_AVAILABLE_ESTABLISHMENTS',
      'SET_SELECTED_ESTABLISHMENT',
      'SET_ESTABLISHMENTS_IS_LOADING',
    ]),
    async getData() {
      this.loading = true;
      this.SET_ESTABLISHMENTS_IS_LOADING(true);
      const availableEstablishments = await fetchAssociatedEstablishments();
      const availableEstablishmentsSorted = _.orderBy(availableEstablishments, 'name');
      this.SET_AVAILABLE_ESTABLISHMENTS(availableEstablishmentsSorted);
      this.list = availableEstablishmentsSorted;
      this.loading = false;
      if (!this.getCurrentEstablishment) {
        // eslint-disable-next-line prefer-destructuring
        this.selected = this.list[0];
        this.SET_SELECTED_ESTABLISHMENT(this.selected);
      } else {
        this.selected = this.getCurrentEstablishment;
      }
      this.SET_ESTABLISHMENTS_IS_LOADING(false);
    },
    onSelect(e) {
      const selectedItem = this.list.find((item) => item.id === e);
      this.SET_SELECTED_ESTABLISHMENT(selectedItem);
      this.$emit('on-select', selectedItem);
      const isCurrentRoute = this.$route.matched.some(({ name }) => name === EVENT_LIST_BY_ESTABLISHMENT);
      if (!isCurrentRoute) {
        this.$router.push({ name: EVENT_LIST_BY_ESTABLISHMENT });
      }
    },
  },

};
</script>
